import TouchableRippleM from "@common/components/button/TouchableRippleM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { FontAwesome5 } from "@expo/vector-icons"
import React from "react"
import { ActivityIndicator, View } from "react-native"

/**
 * A login button whose label wraps (« Continuer avec un numéro de téléphone »),
 * drawn like `FilledButtonM`: outlined by default, `filled` for the primary.
 * Paper's button holds its label on one line on iOS and Android, and those
 * labels do not fit a phone's width.
 */
export const LoginWrapButton = ({
    icon,
    label,
    onPress,
    width,
    disabled,
    loading,
    filled,
}) => {
    const inactive = disabled || loading
    const textColor = filled
        ? disabled
            ? theme.colors.light
            : theme.colors.white
        : theme.colors.primary
    return (
        <TouchableRippleM
            onPress={onPress}
            disabled={inactive}
            accessibilityRole="button"
            accessibilityLabel={label}
            accessibilityState={{ disabled: !!inactive }}
            style={{
                width,
                minHeight: 50,
                justifyContent: "center",
                paddingHorizontal: 16,
                paddingVertical: 10,
                borderRadius: 15,
                ...(filled
                    ? {
                          backgroundColor: disabled
                              ? theme.colors.lightMore
                              : theme.colors.primary,
                      }
                    : {
                          borderWidth: 1,
                          borderColor: theme.colors.light,
                          opacity: disabled ? 0.5 : 1,
                      }),
            }}
        >
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {loading ? (
                    <ActivityIndicator size="small" color={textColor} />
                ) : (
                    !!icon && (
                        <FontAwesome5
                            name={icon}
                            solid
                            size={16}
                            color={textColor}
                        />
                    )
                )}
                <TextM
                    fontSize={15}
                    fontWeight="ExtraBold"
                    color={textColor}
                    style={{
                        marginLeft: icon || loading ? 10 : 0,
                        flexShrink: 1,
                        textAlign: "center",
                        textTransform: "uppercase",
                        letterSpacing: 1,
                    }}
                    wrap
                >
                    {label}
                </TextM>
            </View>
        </TouchableRippleM>
    )
}

const DESKTOP_MIN_WIDTH = 800

// The login screens share one column: full width on a phone, a readable
// column on a desktop browser instead of fields stretched across the screen.
export const loginContentWidth = (dimensions) =>
    dimensions?.width < DESKTOP_MIN_WIDTH ? dimensions?.width - 40 : 400

/** On a desktop browser the column sits in a quiet card; a phone gets none. */
export const LoginCard = ({ dimensions, children }) =>
    dimensions?.width < DESKTOP_MIN_WIDTH ? (
        <View style={{ alignItems: "center" }}>{children}</View>
    ) : (
        <View
            style={{
                alignItems: "center",
                marginTop: 8,
                paddingVertical: 36,
                paddingHorizontal: 32,
                borderRadius: 20,
                borderWidth: 1,
                borderColor: theme.colors.lightMore,
                backgroundColor: theme.colors.white,
            }}
        >
            {children}
        </View>
    )

/** « ou » between two ways of signing in. */
export const OrDivider = ({ width }) => (
    <View
        style={{
            width,
            flexDirection: "row",
            alignItems: "center",
            marginVertical: 20,
        }}
    >
        <View
            style={{
                flex: 1,
                height: 1,
                backgroundColor: theme.colors.lightMore,
            }}
        />
        <TextM
            fontSize={13}
            color={theme.colors.grey}
            style={{ marginHorizontal: 14 }}
        >
            ou
        </TextM>
        <View
            style={{
                flex: 1,
                height: 1,
                backgroundColor: theme.colors.lightMore,
            }}
        />
    </View>
)
